import React from 'react'
import Banners from '../../components/Banners/Banners'
import Products from '../../components/Products/Products'
import './MainPage.css'
import BtnWhatsapp from '../../components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../../components/Cart/Cart'
export default function MainPage({ logo }) {
    return (
        <section className='main-page'>
            <Banners />
            <Products />
            <BtnWhatsapp />
            <Cart />
        </section>
    )
}
